import { defineMessages } from 'react-intl';

/** The copy of the "Get every release" block editor (design presave-subscriptions d6). */
export const presaveSubscribeMessages = defineMessages({
  title: { id: 'app.sml.smartlinks.blocks.presaveSubscribe.name', defaultMessage: 'Get every release' },
  help: {
    id: 'app.sml.presaveSubscribe.block.help',
    defaultMessage:
      'Fans connect once. Each new release lands in their library on release day, and they get an email when it is out.',
  },
  servicesLabel: { id: 'app.sml.presaveSubscribe.block.servicesLabel', defaultMessage: 'Services fans can pick' },
  emailOnly: { id: 'app.sml.presaveSubscribe.block.emailOnly', defaultMessage: 'Email only for now' },
  emailNote: {
    id: 'app.sml.presaveSubscribe.block.emailNote',
    defaultMessage: 'Every fan can also leave an email. The block always offers it.',
  },
  noService: { id: 'app.sml.presaveSubscribe.block.noService', defaultMessage: 'Pick at least one service.' },
  detail: {
    id: 'app.sml.presaveSubscribe.block.detail',
    defaultMessage: '{count, plural, one {# service} other {# services}} and email',
  },
  detailEmailOnly: { id: 'app.sml.presaveSubscribe.block.detailEmailOnly', defaultMessage: 'Email only' },
  deleteWarning: {
    id: 'app.sml.presaveSubscribe.block.deleteWarning',
    defaultMessage: 'Fans who subscribed stay subscribed. You see them on the Fans page.',
  },
});
